'use client';

import '../../styles/guide.css';

import { Container as UiContainer } from '@actr/ui/src/components/container';
import React, { FC, memo, PropsWithChildren } from 'react';

import configs from '@/configs';

import * as Styled from './style.css';

export type ContentPageProps = {
  title: string;
  content: string;
}

const BaseContentPage: FC<ContentPageProps & PropsWithChildren> = ({ title, content, children }) => (
  <UiContainer>
    <div className={Styled.Container}>
      <div className={Styled.WithStyle}>
        {children}
        <div itemScope itemType="https://schema.org/Article">
          <span style={{ display: 'none' }} itemProp="image">
            {configs.baseLogo}
          </span>
          <h1 itemProp="headline">{title}</h1>
          <div
            className={Styled.Wrapper}
            itemProp="articleBody"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          <span style={{ display: 'none' }} itemProp="author" itemScope itemType="https://schema.org/Person">
            <a itemProp="url" href={configs.aviakassaURL}>
              <span itemProp="name">Авиакасса</span>
            </a>
          </span>
        </div>
      </div>
    </div>
  </UiContainer>
);

export default memo(BaseContentPage);
